import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import pkg from '../../../../package.json';

interface TelemetryParams {
	applicationId: string;
	clientToken: string;
	service: string;
	env: string;
}

export const useInitTelemetry = ({ applicationId, clientToken, service, env }: TelemetryParams) => {
	useEffect(() => {
		if (['production', 'staging'].includes(env)) {
			datadogRum.init({
				applicationId: applicationId,
				clientToken: clientToken,
				site: 'datadoghq.com',
				service: service,
				env: env,
				version: pkg.version,
				sessionSampleRate: 100,
				sessionReplaySampleRate: 20,
				trackUserInteractions: true,
				trackResources: true,
				trackLongTasks: true,
				defaultPrivacyLevel: 'mask-user-input',
			});

			datadogLogs.init({
				clientToken: clientToken,
				site: 'datadoghq.com',
				service: service,
				env: env,
				version: pkg.version,
				forwardErrorsToLogs: true,
				sessionSampleRate: 100,
			});
		}
	}, [applicationId, clientToken, service, env]);
};
